import React, { FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'
import { GestureResponderEvent } from 'react-native'

import { noop } from 'lodash-es'
import styled, { useTheme } from 'styled-components/native'

import { ButtonSize } from '../../atoms/baseButton/BaseButton'
import { TertiaryButton as TertiaryTextButton } from '../../atoms/tertiaryButton/TertiaryButton'
import TertiaryIconButton from '../../atoms/tertiaryIconButton/TertiaryIconButton'
import { tID } from '../../utils/utils'
import { XIcon } from '../icons/XIcon'

export interface XButtonProps {
  onPress: (event: GestureResponderEvent) => void
  fillColor?: string
  iconColor?: string
  showExitText?: boolean
  testID?: string
  size?: number
  alternateText?: React.ReactNode
  accessibilityLabel?: string
  importantForAccessibility?: 'auto' | 'yes' | 'no' | 'no-hide-descendants'
}

const Wrapper = styled.View({
  alignItems: 'center',
  borderRadius: '50px',
})

const Exit = ({
  onPress,
  alternateText,
  testID,
}: {
  onPress?: (e: GestureResponderEvent) => void
  alternateText?: React.ReactNode
  testID?: string
}) => {
  return (
    <TertiaryTextButton
      isSmall
      text={alternateText ? alternateText : <FormattedMessage defaultMessage='Exit' description='exit button' />}
      onPress={onPress ?? noop}
      testID={testID}
    />
  )
}

export const XButton: FunctionComponent<XButtonProps> = ({
  onPress,
  fillColor,
  iconColor,
  showExitText = true,
  testID = 'XButton',
  size = 18,
  alternateText,
  accessibilityLabel,
  importantForAccessibility,
}) => {
  const { breakpoints, colors } = useTheme()

  return (
    <Wrapper>
      {!breakpoints.isMobileSized && showExitText ? (
        <Exit onPress={onPress} alternateText={alternateText} testID={tID(testID)} />
      ) : (
        <TertiaryIconButton
          size={ButtonSize.SMALL}
          iconColor={iconColor}
          leftIcon={<XIcon fillColor={fillColor || colors.iconDefault} size={size} />}
          onPress={onPress}
          accessibilityLabel={accessibilityLabel}
          testID={tID(testID)}
          importantForAccessibility={importantForAccessibility}
        />
      )}
    </Wrapper>
  )
}
